import axios from 'axios';
import { retrieveAccessToken } from '../../../../shared/infra/auth/RetrieveAccessToken';

export async function findCourses() {
  const accessToken = await retrieveAccessToken({ required: false });
  const response = await axios.get('/api/viewer/course', {
    headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {}
  });
  return response.data;
}
